import { toURL } from '~/utils/urlResolver'

import type { MagazineImageProps } from '../MagazineImage/MagazineImage'
import MagazineImage from '../MagazineImage/MagazineImage'

export interface ArtworkImageProps extends MagazineImageProps {
  artwork?: any
  testID?: string
  defaultCaption?: {
    artistName: string
    artworkTitle: string
    artworkDate: number
  }
}

export default function ArtworkImage({ ...props }: ArtworkImageProps) {
  return (
    <MagazineImage
      {...props}
      link={props.artwork && toURL(props.artwork.url)}
    />
  )
}
